// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const Sense = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    /*eslint-disable max-len */
    return (
        <G {...gProps}>
            <Path d="M20,9.47c-2.3,0-6.2-.42-6.2-2s3.9-2,6.2-2,6.2.42,6.2,2S22.3,9.47,20,9.47Zm0-3c-3.13,0-5.05.67-5.2,1,.15.3,2.08,1,5.2,1s5-.64,5.19-1C25,7.1,23.05,6.47,20,6.47Z" />
            <Path d="M20,10.94c-5.25,0-10.56-1.19-10.56-3.47S14.75,4,20,4,30.56,5.19,30.56,7.47,25.25,10.94,20,10.94ZM20,5c-5.83,0-9.56,1.46-9.56,2.47S14.17,9.94,20,9.94s9.56-1.46,9.56-2.47S25.83,5,20,5Z" />
            <Path d="M20,30.39c-5.25,0-10.56-1.19-10.56-3.47a.5.5,0,0,1,1,0c0,1,3.72,2.47,9.56,2.47s9.56-1.46,9.56-2.47a.5.5,0,0,1,1,0C30.56,29.2,25.25,30.39,20,30.39Z" />
            <Path d="M23.13,36H16.87a7.43,7.43,0,0,1-7.43-7.43V7.47a.5.5,0,0,1,1,0V28.57A6.43,6.43,0,0,0,16.87,35h6.27a6.43,6.43,0,0,0,6.43-6.43V7.47a.5.5,0,1,1,1,0V28.57A7.43,7.43,0,0,1,23.13,36Z" />
        </G>
    );
    /*eslint-enable max-len */
};

export default Sense;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/devices/sense/index.js